import React from 'react';
import './Skeleton.css';

export default function Skeleton({ width = '100%', height = 16, rounded = 8, className = '' }) {
  return (
    <div
      className={`ui-skeleton ${className}`}
      style={{ width, height, borderRadius: rounded }}
      aria-hidden="true"
    />
  );
}

export function TableSkeleton({ rows = 5, cols = 6 }) {
  return (
    <div className="ui-skeleton-table">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="ui-skeleton-row">
          {Array.from({ length: cols }).map((__, c) => (
            <Skeleton key={c} height={14} />
          ))}
        </div>
      ))}
    </div>
  );
}
